import React from "react";
import loading from "./loader.svg";
import classnames from "classnames";

import styles from "./LoadingScreen.scss";

class LoadingScreen extends React.Component {
  render() {
    return (
      <div
        className={classnames(styles.loadingScreen, {
          hidden: !this.props.loading
        })}
      >
        <img src={loading} className={styles.loadingIcon} />
      </div>
    );
  }
}

export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/routes/common/loadingScreen/LoadingScreen.js